import React, { useState } from 'react'

import { ReactComponent as LoginBg } from '../../assets/images/login-bg.svg'
import { ReactComponent as Logo } from '../../assets/images/logo.svg'

import styles from './LoginReset.module.sass'
import useForgotPassword from '../../hooks/useForgotPassword'
import { Link } from 'react-router-dom'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'

const ForgotPassword = () => {
	const [username, setUsername] = useState('')
	const [success, sendingInfo, error, reset] = useForgotPassword()

	const handleSubmit = (e) => {
		e.preventDefault()
		if (!(sendingInfo || success)) {
			reset(username)
		}
	}

	const handleInputChange = (e) => {
		const target = e.target
		setUsername((prevState) => target.value)
	}

	return (
		<>
			<Logo className={styles['logo']} />
			<HStack
				className={styles['main']}
				columns={[1, 1]}
				justify='stretch'
			>
				<VStack align='center' justify='space-around'>
					<Widget
						className={styles['banner']}
						paddings={['xlarge', 'large', '']}
					>
						<h1>
							Nós somos <strong>Trust!</strong>
						</h1>
						<p>
							<strong>Gestão Integrada de Saúde</strong>
						</p>
						<p>
							Terá de realizar login para continuar. Se pretende
							obter qualquer informação, por favor,{' '}
							<a href='mailto:trust@trustsaude.pt'>
								contacte-nos.
							</a>
						</p>
					</Widget>
					<LoginBg className={styles['illustration']} />
				</VStack>
				<VStack
					align='center'
					justify='center'
					className={styles['right-side']}
				>
					<div className={`${styles['form-container']}`}>
						<form
							onSubmit={handleSubmit}
							disabled={sendingInfo || success}
						>
							{!success && (
								<h1 className={styles['has-subtitle']}>
									Recuperar password
								</h1>
							)}
							{success && (
								<h1 className={styles['has-subtitle']}>
									Recuperação bem sucedida
								</h1>
							)}
							{!success && (
								<small>Por favor insira o seu username</small>
							)}
							{success && (
								<small>
									Será enviado um e-mail com as instruções de
									recuperação de password
								</small>
							)}
							<div className={styles['text-inputs']}>
								{error && (
									<div className={styles['message']}>
										<small>{error.message}</small>
									</div>
								)}
								{sendingInfo && (
									<div className={styles['message']}>
										<small>Sending info</small>
									</div>
								)}
								<TextInput
									tint='light'
									className={styles['text-input']}
									type='text'
									name='username'
									placeholder='username'
									required
									value={username}
									onChange={handleInputChange}
								/>
							</div>
							<div className={styles['form-actions']}>
								<ActionButton
									className={styles['login-button']}
									primary
									type='submit'
								>
									Reset
								</ActionButton>
							</div>
						</form>
						<div className={styles['extra-actions']}>
							<Link to='/login'>
								<small>Voltar ao login</small>
							</Link>
						</div>
					</div>
				</VStack>
			</HStack>
		</>
	)
}

export default ForgotPassword
